import React from 'react';

import CreateSessionForm from '../../components/Forms/CreateSessionForm';

const CreateSessionPage = () => <CreateSessionForm isManaging={false} />;

export default CreateSessionPage;
